import React from 'react';
import CosmicResultsView from './ResultsView.cosmic';
import BackToJourney from '../launch/BackToJourney';

/**
 * Results View Wrapper
 * Routes all results through the Cosmic results view.
 * Legacy ResultsView is no longer active.
 */
const ResultsViewWrapper = (props) => {
  return (
    <>
      {/* S5b.4: in a launched tab, the way back to the client's journey. */}
      <BackToJourney tone="dark" />
      <CosmicResultsView {...props} />
    </>
  );
};

export default ResultsViewWrapper;
